// Llamadas a /api/admin/setting/*. Mismo origen en producción (rewrite de vercel.json a Render) para que la cookie
// de sesión sea de primera parte en Safari: ver adminApi.js.
import axios from 'axios';
import { ADMIN_API } from './adminApi';

const base = () => `${ADMIN_API}/api/admin/setting/`;

export const settingGet = (ruta) => axios.get(base() + ruta, { withCredentials: true }).then((r) => r.data);
export const settingPost = (ruta, cuerpo) => axios.post(base() + ruta, cuerpo, { withCredentials: true }).then((r) => r.data);
